// WEATHER PAGE
const app = {
    init: (settings) => {   

        app.config = {
            latitude: "",
            longitude: "",
            key: '2a8029b11a6c3cc7a196e8d7dd03ce67',
            lang: $('html').attr('lang'),
            units: 'metric',
            exclude: "current,hourly,minutely",
            icon_mapping: {
                "01d": "sun",
                "01n": "moon",
    
                "02d": "sun_clouds",
                "02n": "moon_clouds",
    
                "03d": "clouds",
                "03n": "clouds",
    
                "04d": "clouds",
                "04n": "clouds",
    
                "09d": "rain",
                "09n": "rain",
    
                "10d": "rain",
                "10n": "rain",
    
                "11d": "lightning",
                "11n": "lightning",
    
                "13d": "sun_rain_snow",
                "13n": "moon_rain_snow",
    
                "50d": "fog",
                "50n": "fog"
            },
            weather_mapping: {
                "Thunderstorm": 'rainy',
                "Drizzle": 'rainy',
                "Rain": 'rainy',
                "Clouds": 'cloudy',
                "Dust": 'sandstorm',
                "Sand": 'sandstorm',
                "Haze": 'sandstorm',
                "Clear": 'clear'
            },
            day_mapping:{
                "ur": "طلوع آفتاب",
                "ar":  "شروق الشمس",
                "en": "Sunrise",
                "fa": "طلوع خورشید",
                "tr": "gündoğumu"
            },
            night_mapping: {
                "ur": "Sunset",
                "ar":  "غروب الشمس",
                "en": "Sunset",
                "fa": "غروب آفتاب",
                "tr": "Gün batımı"
            }
        };
        
       
        // Allow overriding the default config
        $.extend(app.config, settings);  

        window.addEventListener('load',  app.getPosition);  //using geolocation
       //window.addEventListener('load',  app.ipApi);  //using ipAPI
    }, 
   
    // fetch current and weekly weather
    fetchWeather: (lat, lon, cty) => {
     
        let latitude = lat;
        let longitude = lon;
       // let city = cty;
 
        let key = app.config.key;
        let lang = app.config.lang;
        let units = app.config.units;
        let exclude = app.config.exclude;
        
        //saudi default
        //let current = `https://api.openweathermap.org/data/2.5/weather?lat=24.774265&lon=46.738586&appid=${key}&lang=${lang}&units=${units}`;
        
        // using city from ipapi
        //let current = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${key}&lang=${lang}&units=${units}`;

        let current = `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&appid=${key}&lang=${lang}&units=${units}`;
        let url = `https://api.openweathermap.org/data/2.5/onecall?lat=${latitude}&lon=${longitude}&exclude=${exclude}&appid=${key}&units=${units}&lang=${lang}`;
  
        //fetch weekly
        fetch(url)
        .then((resp) => {
            if (!resp.ok) throw new Error(resp.statusText);
            return resp.json();
        })
        .then((data) => { 
            app.showWeeklyTab(data);  

            $(".daypart:not([data-dt='current'])").on('click', function(){ 
                var dt = $(this).data('dt'); 
                var dis = $(this);
                app.fetchWeeklyWeather(data, dt, dis);
            });


            //fetch current 
            fetch(current)
            .then((resp) => {
                if (!resp.ok) throw new Error(resp.statusText);
                return resp.json();
            })
            .then((data) => {  
                app.showWeather(data);  
                 
                $(".daypart[data-dt='current']").on('click', function(){  
                    var dt = $(this).data('dt'); 
                    var dis = $(this);
                    app.fetchWeeklyWeather(data, dt, dis);
                });
                
                
            })
            .catch(console.err); 

        })
        .catch(console.err);   

        
    },
  
    // geolocation
    getPosition: (ev) => {   
        let opts = {
            enableHighAccuracy: false,
            timeout: 1000 * 10, //10 seconds
            maximumAge: 1000 * 60 * 5, //5 minutes
            };
            //navigator.geolocation.getCurrentPosition(app.fetchWeather, app.error, opts); 
            navigator.geolocation.getCurrentPosition(app.location, app.error, opts);  
    },
    
    //current location
    location: (position)=> { 
        let lat = position.coords.latitude
        let lon = position.coords.longitude   
 
        //for current weather data
        app.fetchWeather(lat, lon); 
        
    },
 
    //if location is error show default location(Riyadh)
    error: (err) => {
        //geolocation failed
        //console.error(err, 'allow browser location');  
        //if failed change to Riyadh location
        app.location( 
            { 
            "coords": 
                {"latitude": 24.774265, "longitude": 46.738586}    
            }
        ) 
    }, 

    ipApi: () => {
        let  myIP, city;

        $.ajaxSetup({ async: false });
        $.get('https://ipapi.co/json/', function (data) {
            myIP = data.ip;
            city = data.city; 

            app.fetchWeather(data.latitude, data.longitude, city);   
         
        }).fail(function(){
            let lat  = 24.774265;
            let lon = 46.738586; 
            city = "Riyadh";
            app.fetchWeather (lat, lon, city);
        });
    },

    // show current weather 
    showWeather: (data) => {
        //console.log(data, 'showWeather()');  
        let row = document.querySelector('#currentWeather');
        let lang = $('html').attr('lang');
        let city = data.name,
            date = new Date(),
            month =  date.toLocaleString(lang, { month: 'long' }),
            day = date.toLocaleString(lang, { day: 'numeric' }),
            year = date.toLocaleString(lang, { year: 'numeric' }),
            currWeatherCondition = "",
            currentIconCondition = "",
            temp = Math.trunc(data.main.temp), 
            weatherDesc ="", 
            sunriseTime = (new Date(data.sys.sunrise * 1000).toTimeString()).split(' ')[0], 
            sunsetTime = (new Date(data.sys.sunset * 1000).toTimeString()).split(' ')[0];

            
        //clear out the old weather and add the new
        // row.innerHTML = '';  
 
        row.innerHTML = data.weather
        .map((weather, idx) => {
            weatherDesc = weather.description;
            currWeatherCondition = weather.main;
            currentIconCondition = weather.icon; 
            let weatherImg = app.config.weather_mapping[currWeatherCondition] === undefined ? 'clear' : app.config.weather_mapping[currWeatherCondition],
                weatherIcon = app.config.icon_mapping[currentIconCondition] === undefined ? 'sun' : app.config.icon_mapping[currentIconCondition],
                dayTimeText = app.config.day_mapping[lang] === undefined ? 'ar' : app.config.day_mapping[lang];
                nightTimeText = app.config.night_mapping[lang] === undefined ? 'ar' : app.config.night_mapping[lang];
 
            row.classList.remove('use-loader');

            return `<div class="weather-outline ${weatherImg} "> 
                    <div class="weather-outline-city">${city}</div>
                        <div class="weather-outline-date"> ${month} ${day}، ${year}</div>
                            <div class="weather-temperature">${temp}</div>
                            <div class="weather-outline-condition">
                                <div class="weather-ico ${weatherIcon}-ico"></div> <div class="weather-outline-status">${weatherDesc}
                            </div></div>
                            <div class="weather-outline-info">
                            <div class="weather-outline-day flex-container align-middle margin-bottom-1">
                                <span class="weather-icon morning-ico">
                                </span>
                                <div class="weather-today">
                                    <div class="weather-details"> ${dayTimeText}</div>
                                    <time>${sunriseTime}</time>
                                </div>
                            </div>
                            <div class="weather-outline-night flex-container align-middle margin-bottom-1"> 
                                <span class="weather-icon night-ico"> 
                                </span> 
                            <div class="weather-today"> 
                                <div class="weather-details"> ${nightTimeText}</div>
                                <time>${sunsetTime}</time>
                            </div>
                        </div>
                    </div>
                </div>` 
        }) 
        .join(' '); 

       //current location
        app.showLocation(data);

        //show current tab data
        app.showCurrentTab(data); 
 
    }, 

     // show location
    showLocation: (data) => { 
        let lang = $('html').attr('lang');
        let location = document.querySelector(".location_js"); 
        // city name translation based on language
        let cityName = data.name;

        // country name translation based on language
        let regionNames = new Intl.DisplayNames([lang], {type: 'region'});
        let region = regionNames.of(data.sys.country);   
 
        location.append(cityName +'  ،'+ region);
    },

    // show tab dates for the week
    showWeeklyTab: (resp) => {
        
        let row = document.querySelector('#weatherWeek'); 
        //clear out the old weather and add the new
        // row.innerHTML = ''; 

      row.innerHTML = resp.daily
        .map((day, idx) => {
           
          if (idx <= 6) {
            let dt = new Date(day.dt * 1000); //timestamp * 1000
            let lang = $('html').attr('lang');
            let weekDay = dt.toLocaleString(lang, { weekday: 'long' });
            let weekMonth = dt.toLocaleString(lang, { month: 'long' });
            let weekDate = dt.toLocaleString(lang, { day: 'numeric' });
            let newDt = ""; 
   
            // if($(this).parent().is(":first-child")){
            //     //console.log("yes this parent first");
            // }

            // dont include first child 
            if(idx !== 0) {  
               newDt = day.dt;
            }

            // if first child change id to "current"
            if(idx == 0) {  
                newDt = "current";
                $(".weather-info").attr("data-dt", "current")
             }
            
              
            return ` <div class="cell"> 
                 <div class="daypart" data-dt="${newDt}"> 
                 <div class="daypart-day">${weekMonth}</div> 
                 <div class="daypart-date">${weekDate} ${weekDay}</div> 
                </div> 
             </div>`;
          }
        })
        .join(' ');

        let el = document.querySelector('.weather-week .cell:first-child .daypart')
        el.classList.add('active');  
        
    }, 

    //current weather data (first tab)
    showCurrentTab: (resp) => { 
        //Current Weather details 

        resp.main.temp_min ?  $('#tempMinMax').text(resp.main.temp_min + "°/" + resp.main.temp_max + "°") : $('#tempMinMax').text("المعلومات غير متوفره حاليا");
        resp.main.humidity ? $('#humidity').text(resp.main.humidity + "%") : $('#humidity').text("المعلومات غير متوفره حاليا");
        resp.wind.speed ? $('#windSpeed').text(resp.wind.speed) : $('#windSpeed').text("المعلومات غير متوفره حاليا");
        resp.visibility ? $('#vision').text(resp.visibility) : $('#vision').text("المعلومات غير متوفره حاليا");
        resp.main.pressure ?  $('#pressure').text(resp.main.pressure) : $('#pressure').text("المعلومات غير متوفره حاليا");
        resp.main.sea_level ? $('#seaCondition').text(resp.main.sea_level) : $('#seaCondition').text("المعلومات غير متوفره حاليا")
          
    },  
 
    // on click change tab weather data based on date
    fetchWeeklyWeather: (resp, attribute, dis) => {  
        $('.weather-week .daypart').removeClass('active');

        var $dt = attribute; 
        
        if ($dt == "current"){ 
            $(".weather-info").attr("data-dt", "current");  
            app.showCurrentTab(resp);
        }else{
            const  $clickedItem  = resp.daily.filter(day => day.dt == $dt);
            $(".weather-info").attr("data-dt", $clickedItem[0].dt );
 
            // updated weather details
            $clickedItem[0].temp.min ?  $('#tempMinMax').text($clickedItem[0].temp.min + "°/" + $clickedItem[0].temp.max + "°") : $('#tempMinMax').text("المعلومات غير متوفره حاليا");
            $clickedItem[0].humidity ? $('#humidity').text($clickedItem[0].humidity + "%") : $('#humidity').text("المعلومات غير متوفره حاليا");
            $clickedItem[0].wind_speed ?  $('#windSpeed').text($clickedItem[0].wind_speed) :  $('#windSpeed').text("المعلومات غير متوفره حاليا"); 
            $('#vision').text("المعلومات غير متوفره حاليا"); 
            $clickedItem[0].pressure ? $('#pressure').text($clickedItem[0].pressure) : $('#pressure').text("المعلومات غير متوفره حاليا");
            $('#seaCondition').text("المعلومات غير متوفره حاليا");      
        }

        dis.addClass('active'); 
        
        // if not on first item hide visibility because there is no visibility on "daily"
      
        // if (dis.parent().index() != 0){
        //     $('#vision').hide(); 
        //     $('#seaCondition').hide();
        // }else{
        //     $('#vision').show(); 
        //     $('#seaCondition').show(); 
        // }  

    }

};
  
var isExisting = document.querySelector('.weather-widget');
if (isExisting) {
    app.init();
}
